import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import { useOrganizationAlertsUnreadCount } from '@/shared/hooks/api/regulatoryNews'
import { useCurrentOrganization } from '@/shared/hooks/api/organization'
import { useLayout } from '@/context/layout-provider'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { applyRegulatoryNewsNavBadge } from '@/features/regulatory-news/apply-regulatory-news-nav-badge'
import { getSidebarData } from './data/sidebar-data'
import { filterNavGroupsBySession } from './filter-nav-groups-by-session'
import { NavGroup } from './nav-group'
import { TeamSwitcher } from './team-switcher'

export function AppSidebar() {
  const { collapsible, variant } = useLayout()
  const { data: session } = useGetUserSession()
  const { data: organization } = useCurrentOrganization()
  const { t } = useTranslation('common')
  const organizationId = session?.organizationId
  const { data: unreadData } = useOrganizationAlertsUnreadCount(organizationId)

  const navGroups = useMemo(() => {
    const filtered = filterNavGroupsBySession(getSidebarData(t).navGroups, {
      isArtemAdmin: session?.isArtemAdmin ?? false,
      canAccessPackagingSuppliers:
        organization?.packagingSuppliersEnabled === true,
      canWriteOrgData: session != null && !session.isReadOnly,
    })
    return applyRegulatoryNewsNavBadge(filtered, unreadData?.count ?? 0)
  }, [session, organization?.packagingSuppliersEnabled, t, unreadData?.count])

  return (
    <Sidebar collapsible={collapsible} variant={variant}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {navGroups.map((props) => (
          <NavGroup key={props.title} {...props} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <ProfileDropdown variant='sidebar' />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
